// Mega Menu Scroll Behavior
document.addEventListener('DOMContentLoaded', function() {
    // Restructure mega menu layout using Bootstrap grid
    function restructureMegaMenu() {
        const megaMenus = document.querySelectorAll('.wp-block-navigation__submenu-container.mega-menu');

        megaMenus.forEach(menu => {
            // Skip if already restructured
            if (menu.classList.contains('mega-menu-restructured')) {
                return;
            }

            // Create Bootstrap row wrapper
            const rowWrapper = document.createElement('div');
            rowWrapper.className = 'row mega-menu-row';

            // Create single empty column spanning 5 columns (hidden on mobile)
            const emptyCol = document.createElement('div');
            emptyCol.className = 'col-md-5 d-none d-md-block mega-menu-empty-col';
            rowWrapper.appendChild(emptyCol);

            // Create column for content (spans 7 columns)
            const contentCol = document.createElement('div');
            contentCol.className = 'col-md-7 mega-menu-content-col';

            // Create inner row for 3-column layout of menu items
            const innerRow = document.createElement('div');
            innerRow.className = 'row mega-menu-inner-row';

            // Move all LI items to the inner row with col-md-4 each
            const menuItems = Array.from(menu.children);
            menuItems.forEach(item => {
                // Wrap each LI in a Bootstrap column
                const colWrapper = document.createElement('div');
                colWrapper.className = 'col-md-4 mega-menu-item-col';
                colWrapper.appendChild(item);
                innerRow.appendChild(colWrapper);
            });

            // Add inner row to content column
            contentCol.appendChild(innerRow);

            // Add content column to row
            rowWrapper.appendChild(contentCol);

            // Replace menu contents with Bootstrap row
            menu.innerHTML = '';
            menu.appendChild(rowWrapper);

            // Mark as restructured
            menu.classList.add('mega-menu-restructured');
        });
    }

    // Run restructuring on page load
    restructureMegaMenu();

    let isScrolling = false;
    let scrollTimeout;

    // Close mega menu on scroll
    window.addEventListener('scroll', function() {
        // Set scrolling flag
        isScrolling = true;

        // Clear existing timeout
        clearTimeout(scrollTimeout);

        // Add class to hide mega menu
        const megaMenus = document.querySelectorAll('.wp-block-navigation__submenu-container');
        megaMenus.forEach(menu => {
            menu.classList.add('mega-menu-hidden');
        });

        // Set timeout to remove the class and scrolling flag after scrolling stops
        scrollTimeout = setTimeout(function() {
            isScrolling = false;
            // Remove the class to allow hover behavior again
            megaMenus.forEach(menu => {
                menu.classList.remove('mega-menu-hidden');
            });
        }, 500);
    });

    // Re-enable mega menu on hover of parent LI (only if not scrolling)
    const megaMenuParents = document.querySelectorAll('li.has-child.mega-menu');
    megaMenuParents.forEach(parent => {
        parent.addEventListener('mouseenter', function() {
            // Only remove hidden class if not currently scrolling
            if (!isScrolling) {
                const megaMenu = this.querySelector('.wp-block-navigation__submenu-container');
                if (megaMenu) {
                    megaMenu.classList.remove('mega-menu-hidden');
                }
            }
        });
    });

    // Also close mega menu when clicking outside
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.main-navigation')) {
            const megaMenus = document.querySelectorAll('.wp-block-navigation__submenu-container');
            megaMenus.forEach(menu => {
                menu.classList.add('mega-menu-hidden');
            });

            // Re-enable after a short delay
            setTimeout(function() {
                megaMenus.forEach(menu => {
                    menu.classList.remove('mega-menu-hidden');
                });
            }, 500);
        }
    });
});

// =============================================================================
// FSE STICKY HEADER BEHAVIOR
// Handles sticky header when .is-position-sticky class is applied by FSE
// =============================================================================
(function() {
    'use strict';

    // Check if header has FSE positioning classes
    function initStickyHeader() {
        const stickyHeader = document.querySelector('.site-header.is-position-sticky');
        const absoluteHeader = document.querySelector('.site-header.is-position-absolute');

        // Handle sticky header (now absolute positioning with scroll effects)
        if (stickyHeader) {
            initStickyBehavior(stickyHeader);
        }

        // Handle absolute header (no scroll behavior needed)
        if (absoluteHeader) {
            initAbsoluteBehavior(absoluteHeader);
        }
    }

    // Replace default hamburger icon with custom one
    function replaceHamburgerIcon() {
        // Hide the default WordPress hamburger button
        const defaultButton = document.querySelector('.wp-block-navigation__responsive-container-open');
        if (defaultButton) {
            defaultButton.style.display = 'none';
        }

        // Create custom hamburger button
        const customButton = document.createElement('button');
        customButton.className = 'custom-mobile-navigation-hamburger-toggle';
        customButton.setAttribute('aria-label', 'Toggle Mobile Menu');
        customButton.setAttribute('aria-haspopup', 'dialog');
        customButton.innerHTML = '<svg width="38" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 30" aria-hidden="true" focusable="false"><rect x="0" y="0" width="38" height="4"></rect><rect x="0" y="13" width="38" height="4"></rect><rect x="0" y="26" width="38" height="4"></rect></svg>';

        // Find the navigation container and insert the custom button
        const mainNavigation = document.querySelector('.main-navigation');
        if (mainNavigation) {
            // Insert before the navigation container
            mainNavigation.parentNode.insertBefore(customButton, mainNavigation);
        }
    }

    // Create and manage custom mobile navigation offcanvas
    function initCustomMobileNavigation() {
        // Create offcanvas element
        const offcanvas = document.createElement('div');
        offcanvas.className = 'custom-mobile-navigation-offcanvas';
        offcanvas.setAttribute('aria-hidden', 'true');

        // Create offcanvas content wrapper
        const offcanvasContent = document.createElement('div');
        offcanvasContent.className = 'custom-mobile-navigation-offcanvas-content';

        // Add navigation content area (no close button needed)
        const navContent = document.createElement('div');
        navContent.className = 'custom-mobile-navigation-offcanvas-nav';

        // Generate mobile menu from main navigation
        const mainNavContainer = document.querySelector('.main-navigation .wp-block-navigation__container');
        if (mainNavContainer) {
            const mobileMenu = document.createElement('div');
            mobileMenu.className = 'menu-mobile';
            const ul = document.createElement('ul');
            ul.className = 'menu-mobile-list';

            // Get top-level navigation items
            const topLevelItems = mainNavContainer.querySelectorAll(':scope > li');
            topLevelItems.forEach(item => {
                const li = document.createElement('li');
                li.className = 'nav-item';

                // Check if item has children
                if (item.classList.contains('has-child')) {
                    li.classList.add('menu-item-has-children');
                }

                // Get the link
                const link = item.querySelector('a.wp-block-navigation-item__content');
                if (link) {
                    const newLink = document.createElement('a');
                    newLink.className = 'nav-link';
                    newLink.href = link.href;
                    newLink.textContent = link.textContent.trim();
                    li.appendChild(newLink);
                }

                ul.appendChild(li);
            });

            mobileMenu.appendChild(ul);
            navContent.appendChild(mobileMenu);

            // Clone CTA button if it exists
            const ctaButton = document.querySelector('.site-header .wp-block-buttons');
            if (ctaButton) {
                const clonedCta = ctaButton.cloneNode(true);
                navContent.appendChild(clonedCta);
            }
        } else {
            // Fallback if navigation not found
            navContent.innerHTML = '<p>Mobile navigation content goes here</p>';
        }
        offcanvasContent.appendChild(navContent);

        offcanvas.appendChild(offcanvasContent);

        // Find site header and append offcanvas to bottom
        const siteHeader = document.querySelector('.site-header');
        if (siteHeader) {
            siteHeader.appendChild(offcanvas);
        }

        // Add click event to hamburger toggle
        const hamburgerToggle = document.querySelector('.custom-mobile-navigation-hamburger-toggle');
        if (hamburgerToggle) {
            hamburgerToggle.addEventListener('click', function() {
                const isOpen = offcanvas.classList.contains('is-open');

                if (isOpen) {
                    closeOffcanvas(offcanvas);
                } else {
                    openOffcanvas(offcanvas);
                }
            });
        }

        // Close on click outside
        offcanvas.addEventListener('click', function(e) {
            if (e.target === offcanvas) {
                closeOffcanvas(offcanvas);
            }
        });

        // Close on escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && offcanvas.classList.contains('is-open')) {
                closeOffcanvas(offcanvas);
            }
        });

        function openOffcanvas(offcanvasElement) {
            offcanvasElement.setAttribute('aria-hidden', 'false');
            offcanvasElement.classList.add('is-open');
            document.body.style.overflow = 'hidden'; // Prevent background scrolling
            document.documentElement.style.overflow = 'hidden'; // Also prevent html scrolling

            // Transform hamburger to X
            hamburgerToggle.classList.add('is-active');
            hamburgerToggle.setAttribute('aria-label', 'Close menu');

            // Make header fully opaque
            const siteHeader = document.querySelector('.site-header');
            if (siteHeader) {
                siteHeader.classList.add('offcanvas-open');
            }
        }

        function closeOffcanvas(offcanvasElement) {
            offcanvasElement.setAttribute('aria-hidden', 'true');
            offcanvasElement.classList.remove('is-open');
            document.body.style.overflow = ''; // Restore scrolling
            document.documentElement.style.overflow = ''; // Restore html scrolling

            // Transform X back to hamburger
            hamburgerToggle.classList.remove('is-active');
            hamburgerToggle.setAttribute('aria-label', 'Open menu');

            // Remove header opacity override
            const siteHeader = document.querySelector('.site-header');
            if (siteHeader) {
                siteHeader.classList.remove('offcanvas-open');
            }
        }
    }

    // Initialize sticky header behavior (fixed overlay with scroll styling)
    function initStickyBehavior(header) {
        // Header is fixed and overlays content — do NOT add body padding
        let isScrolled = false; // Track if we've scrolled past threshold

        // Handle scroll events for styling changes only
        function handleScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollThreshold = 50; // Start styling changes after 50px scroll

            if (scrollTop > scrollThreshold) {
                if (!isScrolled) {
                    header.classList.add('is-scrolling-sticky');
                    isScrolled = true;
                }
            } else {
                if (isScrolled) {
                    header.classList.remove('is-scrolling-sticky');
                    isScrolled = false;
                }
            }
        }

        // Initialize
        handleScroll(); // Set initial visual state
        window.addEventListener('scroll', handleScroll, { passive: true });
    }

    // Initialize absolute header behavior (just set up height variable)
    function initAbsoluteBehavior(header) {
        // No special behavior needed for absolute headers
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initStickyHeader();
            replaceHamburgerIcon();
            initCustomMobileNavigation();
        });
    } else {
        initStickyHeader();
        replaceHamburgerIcon();
        initCustomMobileNavigation();
    }
})();